import '@/globals.js' // eslint-disable-line no-unused-vars
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import http from '@/http'
import '@/registerServiceWorker'
import bootstrap from 'bootstrap' // eslint-disable-line no-unused-vars
import VeeValidate, { Validator } from 'vee-validate'
import pt_BR from 'vee-validate/dist/locale/pt_BR'
import VueTheMask, { mask } from 'vue-the-mask'
import PrettyCheckbox from 'pretty-checkbox-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCookies from 'vue-cookies'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import lztring from 'lz-string'
import VueAnalytics from 'vue-analytics'
import localeValidator from '@/locale/validator'
import '@/filters'
require('select2/dist/js/i18n/pt-BR')

const isProd = process.env.NODE_ENV === 'production'

Vue.config.devtools = !isProd
Vue.config.productionTip = !isProd

Vue.use(VueCookies)
Vue.use(VeeValidate, { locale: 'pt_BR' })
Validator.localize('pt_BR', pt_BR)
Validator.localize('pt_BR', localeValidator)
Vue.use(VueTheMask)
Vue.directive(mask)
Vue.use(PrettyCheckbox)
Vue.use(VueSweetalert2)
Vue.use(VueCookies)
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_SITE_KEY })
Vue.use(VueAnalytics, {
  id: isProd ? 'UA-154674350-1' : 'UA-154674350-1',
  router,
  debug: {
    enable: !isProd,
    sendHitTask: true
  }
})

Vue.prototype.$http = http
Vue.prototype.env = process.env.NODE_ENV

// load countries
var countries = localStorage.getItem('settings::countries')
if (!countries) {
  http.get('/api/misc/countries').then((response) => {
    localStorage.setItem('settings::countries', lztring.compressToUTF16(JSON.stringify(response.data)))
    store.state.countries = response.data
  })
} else {
  countries = JSON.parse(lztring.decompressFromUTF16(countries))
  store.state.countries = countries
}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
